<template>
  <div class="trainers-list trainers-list-scrollable">
    <div class="trainersCardsWrapper">
      <TrainerCard
        v-for="trainer in list"
        :id="`id-${trainer.id}`"
        :key="trainer.id"
        :trainer="trainer"
      />
    </div>
    <div class="pagination-wrapper d-none d-md-flex">
      <span class="gray">
        {{ $t('common.showing_results') }}
        {{ from || 1 }} - {{ to || 0 }}
        {{ $t('common.of') }}
        {{ total }}
      </span>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-count="pagesNumber"
        :hide-on-single-page="pagesCounter"
        :current-page.sync="currentPage"
        @current-change="changePage"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import TrainerCard from '~/components/Search/TrainerCard'

export default {
  name: 'DesktopList',
  components: {
    TrainerCard
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    page: {
      type: Number,
      default: 1
    },
    pagesNumber: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      leftColumn: null,
      trainersList: null,
      trainersListHeight: null,
      leftColumnHeight: null,
      currentPage: null,
      unsubscribe: null,
      CACHED_PATHS: ['location-trainer-id', 'location-club-id']
    }
  },
  computed: {
    ...mapGetters({
      cachedTrainers: 'search/getCachedTrainers',
      focusedTrainer: 'search/getFocusedTrainer',
      from: 'search/getFrom',
      to: 'search/getTo',
      total: 'search/getTotal'
    }),
    pagesCounter() {
      return !!this.pagesNumber && this.pagesNumber === 1
    }
  },
  mounted() {
    this.initializeElements()
    this.subscribeOnMutations()
    this.currentPage = this.page

    // Dirty hack!
    setTimeout(() => {
      this.focusTrainer()
    }, 0)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollListener)
    this.leftColumn.style.position = 'absolute'
    this.leftColumn.classList.remove('left-column-fixed')
    this.leftColumn.classList.remove('left-column-absolute')

    this.cacheDesktopList()

    this.unsubscribe()
  },
  methods: {
    ...mapActions({
      cacheTrainers: 'search/CACHE_TRAINERS',
      setCurrentPage: 'search/SET_CURRENT_PAGE'
    }),
    changePage() {
      window.scrollTo({
        top: 0,
        behavior: 'auto'
      })
      this.$emit('changePageDesktop', this.currentPage)
    },
    initializeElements() {
      this.leftColumn = document.querySelector('#filtersColumn')
      this.trainersList = document.querySelector('.trainersCardsWrapper')

      this.trainersListHeight = this.trainersList.getBoundingClientRect().height
      this.leftColumnHeight = this.leftColumn.getBoundingClientRect().height

      this.handleScrollDesktop()
    },
    scrollListener() {
      const leftColumnOffset = this.leftColumn.getBoundingClientRect().top

      const trainersListBottom = this.trainersList.getBoundingClientRect()
        .bottom
      const leftColumnOffsetBottom = this.leftColumn.getBoundingClientRect()
        .bottom

      if (trainersListBottom <= leftColumnOffsetBottom) {
        this.leftColumn.classList.remove('left-column-fixed')
        this.leftColumn.classList.add('left-column-absolute')
      }
      if (leftColumnOffset > 120) {
        this.leftColumn.classList.remove('left-column-absolute')
        this.leftColumn.classList.add('left-column-fixed')
      }

      if (!this.list.length) {
        window.removeEventListener('scroll', this.scrollListener)
      }
    },
    handleScrollDesktop() {
      if (this.trainersListHeight < this.leftColumnHeight) {
        this.leftColumn.style.position = 'absolute'
        this.leftColumn.classList.remove('left-column-fixed')
        this.leftColumn.classList.remove('left-column-absolute')
      } else {
        this.leftColumn.style.position = 'fixed'

        window.addEventListener('scroll', this.scrollListener)
      }
    },
    subscribeOnMutations() {
      //  subscribe on SET mutations to load trainers list
      //  every time SET mutation occurs
      this.unsubscribe = this.$store.subscribe(async (mutation) => {
        if (/search\/(RE)?SET/.test(mutation.type)) {
          //  emit event to load trainers list after SET mutations in the state
          await this.setCurrentPage(1)
          this.$emit('anotherQuery')
        }
      })
    },
    cacheDesktopList() {
      const cachedRoute = this.CACHED_PATHS.some((item) =>
        this.$route.name.includes(item)
      )

      //  cache trainers list only if transition to CACHED_PATHS
      //  and if it`s loaded
      cachedRoute && this.list.length && this.cacheTrainers(this.list)
    },
    focusTrainer() {
      const stringID = `#id-${this.focusedTrainer}`

      const focusedCard = document.querySelector(stringID)

      focusedCard &&
        focusedCard.scrollIntoView({ block: 'center', behavior: 'auto' })
    }
  }
}
</script>

<style scoped lang="scss">
.pagination-wrapper {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 100px;
}

@media (min-width: 992px) {
  .pagination-wrapper {
    margin-bottom: 0;
  }
}
</style>
